function CaminoLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1010"
      height="273"
      viewBox="0 0 1010 273"
      fill="none"
    >
      <path
        d="M983.001 42.4156L911.761 31.5C910.142 31.2594 908.523 31.1281 906.948 31.1281C891.523 31.1281 877.935 42.4594 875.529 58.2531L850.17 225.203C847.523 242.616 859.469 258.934 876.798 261.581L948.037 272.497C956.439 273.787 964.819 271.709 971.667 266.656C978.515 261.603 982.979 254.187 984.27 245.744L1009.65 78.7937C1010.94 70.35 1008.86 61.9281 1003.83 55.0594C998.776 48.1906 991.38 43.7062 983.001 42.4156ZM946.309 232.05L890.429 223.497L913.468 71.9687L969.348 80.5219L946.309 232.05Z"
        fill="#272727"
      />
      <path
        d="M784.882 15.4656L773.505 147.809L729.987 10.7188L679.576 6.34375L659.644 238.241L699.071 241.653L712.986 79.6469L763.593 247.253L804.377 250.775L824.309 18.8781L784.882 15.4656Z"
        fill="#272727"
      />
      <path
        d="M586.64 1.81535L576.466 234.333L616.007 236.062L626.18 3.54464L586.64 1.81535Z"
        fill="#272727"
      />
      <path
        d="M497.845 233.559L537.403 232.706L532.481 0L481.895 1.07187L442.731 100.341L399.41 2.84375L348.802 3.91562L353.747 236.622L393.305 235.791L389.761 68.9719L432.579 167.366L455.793 166.884L494.432 72.7344L497.845 233.559Z"
        fill="#272727"
      />
      <path
        d="M268.023 171.588L274.828 243.644L314.233 239.903L292.353 8.18126L188.951 18.025C180.484 18.8344 172.848 22.9031 167.443 29.4656C162.039 36.05 159.501 44.3406 160.289 52.8281L168.625 141.137L145.148 143.369L152.828 182.569L172.366 180.709L179.171 252.766L218.576 249.025L211.771 176.969L268.023 171.588ZM200.416 56.8531L256.69 51.4938L264.282 132.016L208.008 137.375L200.416 56.8531Z"
        fill="#272727"
      />
      <path
        d="M6.25753 55.0375C1.20337 61.8844 -0.897055 70.3062 0.350074 78.75L25.1833 245.787C27.765 263.2 43.9996 275.253 61.3282 272.65L135.937 261.472L134.012 221.572L63.166 232.181L40.6302 80.5875L111.476 69.9781L101.718 31.2594L27.1087 42.4375C18.7069 43.7062 11.2898 48.1687 6.25753 55.0375Z"
        fill="#272727"
      />
    </svg>
  );
}

export { CaminoLogo };
